import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {FooterBar} from 'shells/modal/footer-bar';

import styles from './small-modal-wrapper.module.css';

type Props = {
    onSave: () => void;
    onFailToConnect: () => void;
    closeModal: () => void;
    saveDisabled?: boolean;
};

export function SmallModalFooter(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    return (
        <div className={styles.footer}>
            <FooterBar
                left={
                    <Button
                        variant='text'
                        size='big'
                        onClick={props.onFailToConnect}
                        noPadding={true}
                    >
                        Cancel
                    </Button>
                }
                right={
                    <SaveButton
                        size='big'
                        // @ts-expect-error
                        onClick={() => {
                            setIsSaving(true);
                            props.onSave();

                            setTimeout(() => {
                                setIsSaving(false);
                                props.closeModal();
                            }, 1000);
                        }}
                        isSaving={isSaving}
                        disabled={props.saveDisabled}
                    />
                }
            />
        </div>
    );
}
